<span class="app-link-button nowrap mat-{{ color }}"><ng-content></ng-content></span>
